import { render } from "./ProjectContext.vue?vue&type=template&id=45cca2f4&scoped=true"
import script from "./ProjectContext.vue?vue&type=script&lang=js"
export * from "./ProjectContext.vue?vue&type=script&lang=js"

import "./ProjectContext.vue?vue&type=style&index=0&id=45cca2f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cca2f4"]])

export default __exports__